import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { resolveWorkspaceRedirectPath } from '../../../../application/navigation/resolveStoredWorkspaceId';

interface WorkspaceRedirectProps {
  buildPath: (workspaceId: string) => string;
  fallbackPath?: string;
}

export default function WorkspaceRedirect({
  buildPath,
  fallbackPath = '/home'
}: WorkspaceRedirectProps) {
  const location = useLocation();
  const target = resolveWorkspaceRedirectPath(buildPath, fallbackPath);

  return <Navigate to={target} replace state={{ from: location }} />;
}
